/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sync_Degraded_Live_Updates_MisroutedInputs */



/**
* | output |
* | --- |
* | "Live updates for this app are delivered to a different environment. Changes appear here only after a manual sync." |
*
* @param {Sync_Degraded_Live_Updates_MisroutedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sync_degraded_live_updates_misrouted = /** @type {((inputs?: Sync_Degraded_Live_Updates_MisroutedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Degraded_Live_Updates_MisroutedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Live-Aktualisierung dieser Anwendung wird an eine andere Umgebung ausgeliefert. Änderungen erscheinen hier erst nach einer manuellen Synchronisierung.")
	return /** @type {LocalizedString} */ ("Live updates for this app are delivered to a different environment. Changes appear here only after a manual sync.")
});